// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  azure: {
    sas: '?sv=2019-12-12&ss=bfqt&srt=sco&sp=rwdlacupx&se=2030-12-18T18:53:42Z&st=2020-12-18T10:53:42Z&spr=https&sig=dJaThqno1ojGsKq4e2aNrSRU6TojCMiMwKw95vsv60k%3D',
    storageAccount: 'avtopiablob',
    containerName: 'avtopia',
  },
  apiBaseUrl: 'https://avtopia-backend.previewbay.com/avtopia/api/v1',
  // apiBaseUrl: 'https://api.avtopia.com/avtopia/api/v1',
  // apiBaseUrl: 'http://localhost:3000/avtopia/api/v1',
  firebaseConfig: {
    apiKey: 'AIzaSyDJMMC48pgDKvuc93o4uuyU_H0IHvkHei0',
    authDomain: 'avtopia-e447d.firebaseapp.com',
    databaseURL: 'https://avtopia-e447d.firebaseio.com',
    projectId: 'avtopia-e447d',
    storageBucket: 'avtopia-e447d.appspot.com',
    messagingSenderId: '113703349449',
    appId: '1:113703349449:web:9167399c11eacaf686f118'
  },
  // firebaseConfig: { //production key new
  //   apiKey: "AIzaSyAkNpwC-YPeAibsdxPOtX-bmPQiFyRo09g",
  //   authDomain: "avtopia-app.firebaseapp.com",
  //   databaseURL: "https://avtopia-app-default-rtdb.firebaseio.com",
  //   projectId: "avtopia-app",
  //   storageBucket: "avtopia-app.firebasestorage.app",
  //   messagingSenderId: "482498302645",
  //   appId: "1:482498302645:web:df8b17ea0022d58deaa4fc",
  //   measurementId: "G-EHQ2TNV1SG"
  // },
  contentTypes: {
    ABOUT_US: '5e6a29225aac64697fdec444',
    TERMS_AND_CONDITIONS: '5e6a29215aac64697fdec443',
    PRIVACY_POLICY: '5e6a29215aac64697fdec442',
    CONTACT_US: '5e6a29215aac64697fdec441'
  },
  API_KEY: '1234',
  PLATFORM: '3',
  FINGER_PRINT: 'Basic bGl2d2VsbDpsaXZ3ZWxsQDEyMw==',
  MAP_API_KEY: 'AIzaSyAbsOHGbBdGA28ziB-AwWZ6PwTGDL9hhXM',
  tokenRememberKey: '',
  tokenKey: 'tokenKey',
  currentUrl: 'https://avtopia.com'
};
